<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Main Content</h6>
      </div>
      
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{alertstatus}}</strong> {{alerttext}}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Title
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                File
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Description
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Action
              </th>
              
            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>{{ item.title }}</td>
              <td class="text-center">
                <img :src="item.cover" alt="Banner Image" style="width: 100px; height: auto;" />
              </td>
              <td>
                <div v-html="truncateHTML(item?.description, 50)"></div>
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i class="fa fa-edit"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item 
            prev  
            :disabled="currentPage === 1" 
            @click="prevPage"
          />
          
          <!-- Page Numbers -->
          <argon-pagination-item 
            v-for="page in totalPages" 
            :key="page" 
            :label="String(page)" 
            :active="currentPage === page" 
            @click="setPage(page)"
          />
          
          <!-- Next Page Button -->
          <argon-pagination-item 
            next  
            :disabled="currentPage === totalPages" 
            @click="nextPage"
          />
        </argon-pagination>
      </div>
      
      <div :class="showModal == true ? 'modal-backdrop': '' "></div>
      <div class="modal fade" :class="showModal == true ? 'show': '' " tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add' ">Add New Main Content</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit Main Content</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required>
                </div>
                <div class="mb-3">
                  <label for="file" class="form-label">File</label>
                  <input type="file" class="form-control" @change="handleFileUpload" :required="method == 'add' " accept="image/*">
                  <div v-if="imgreview" class="m-4">
                    <img :src="imgreview" alt="" srcset="" style="max-height: 100px;">
                  </div>
                </div>
                <div class="mb-3">
                  <select name="pages" id="pages" v-model="formData.pages" class="form-select form-select-sm" required :disabled="method == 'edit'">
                    <option value="advisory_service_all">advisory service all</option>
                    <option value="advisory_usecase_all">advisory usecase all</option>
                    <option value="advisory_learn_more">advisory learn more</option>
                    <option value="bom_service_all">bom service all</option>
                    <option value="bom_usecase_all">bom usecase all</option>
                    <option value="bom_learn_more">bom learn more</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="deskripsi" class="form-label">Deskripsi</label>
                  <CustomQuillEditor
                    theme="snow" 
                    v-model:content="formData.description"
                    contentType="html"
                    class="large-editor"
                  />
                  
                  <small class="text-danger">*Tambahkan https:// jika itu link</small>
                </div>
                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  
</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import CustomQuillEditor from "@/components/CustomQuillEditor.vue";


export default {
  data() {
    return {
      main_contentList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage:20,
      sortOrder: 'asc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        title: '',
        cover: null,
        pages: 'advisory_service_all',
        description: ''
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      pages: 'advisory_service_all',
      imgreview: null
    };
  },
  components: {
   ArgonPagination,
   ArgonPaginationItem,
   ArgonAlert,
   CustomQuillEditor
   },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchmain_contentList();
  },
  computed: {
    totalItems() {
      return this.main_contentList.length;
    },
    paginatedData() {
      return this.main_contentList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchmain_contentList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/main_content",
        headers: {
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {   
          if (response.data?.message == 'success') {
            
            this.main_contentList = response.data.data
            this.totalPages =  1// Update the total number of pages (this depends on how the API returns pagination info)
          }else{
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchmain_contentList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchmain_contentList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchmain_contentList();
    },
    updateItemsPerPage() {
      this.fetchmain_contentList();
    },
    updatesoftby(){
      this.fetchmain_contentList();
    },
    cari(){
      this.fetchmain_contentList();
    },
    changepages(){
      this.fetchmain_contentList();
    },
    truncateHTML(htmlContent, maxLength) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlContent || '';
      const textContent = tempElement.textContent || tempElement.innerText || '';

      // Potong teks jika panjangnya melebihi maxLength
      if (textContent.length > maxLength) {
        return textContent.slice(0, maxLength) + '...';
      }

      return htmlContent;
    },
    
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        title: '',
        file: null,
        description: ''
      };
      this.imgreview = null;
      this.method = 'add';
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.cover = event.target.files[0]; // Capture the file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      const data = new FormData();
      var config = {}

        data.append('title', this.formData.title);
        data.append('cover', this.formData.cover);
        data.append('pages', this.formData.pages);
        data.append('description', this.formData.description);
        
        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/main_content',
          headers: { 
            'Authorization': 'Bearer '+ access_token // Replace with the actual token
          },
          data: data,
        };

        console.log(this.formData);
        
      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchmain_contentList();
           
            this.$swal({
              title: "Success!",
              text: "Update data success",
              icon: "success"
            });
          
          this.closeModal(); // Close modal after successful submission
        }else{
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err
        console.error("Error fetching data:", error);
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/main_content/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchmain_contentList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit (item) {
      this.formData = {
        title: item.title,
        description: item.description,
        cover: null,
        id: item.id,
        pages: item.pages
      };
      this.imgreview = item.cover;
      this.showModal = true;
      this.method = 'edit';
    }

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block; /* Override display to block */
}
.modal-backdrop {
  opacity: 50%;
}
</style>